import { combineReducers } from 'redux';
import { formNewReducer } from './form-new.reducer';
import { userReducer } from './user.reducer';
import { offlineReducer } from './offline.reducer';

const rootReducer = combineReducers({
  offlineReducer: offlineReducer,
  formState: formNewReducer,
  userState: userReducer
});

export default rootReducer;
